// removed by extract-text-webpack-plugin
module.exports = {"main":"rate-calculator-main","calculatorTitle":"rate-calculator-calculatorTitle","calculatorContent":"rate-calculator-calculatorContent","address":"rate-calculator-address","spinnerLine":"rate-calculator-spinnerLine","spinner":"rate-calculator-spinner"};


//////////////////
// WEBPACK FOOTER
// ./src/components/rate/calculator/index.css
// module id = 1826
// module chunks = 0